// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"171":"f3b54936","595":"92912efa","936":"f3b54936","938":"68b88b66"}[chunkId] + ".chunk.css";
};